import React from "react";
import ReactECharts from "echarts-for-react";

const DualAxisChart = () => {
  const options = {
    title: {
      text: "Over Time",
      left: "left",
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
        color: "#333",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        label: {
          backgroundColor: "#6a7985",
        },
      },
    },
    xAxis: {
      type: "category",
      data: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug",
        "Sep", "Oct", "Nov", "Dec"
      ],
      axisLine: {
        lineStyle: {
          color: "#ccc",
        },
      },
      axisLabel: {
        color: "#666",
      },
      splitLine: {
        lineStyle: {
          type: "dashed",
          color: "#EFEFEF",
        },
    },
    axisTick: {
        show: false, // Disable small ticks below the axis line
      },
    },
    yAxis: [
      {
        type: "value",
        axisLine: {
          show: true,
          lineStyle: {
            color: "#DADADA", // Left Y-axis color
          },
        },
        axisLabel: {
          color: "#F95C39", // Match label color with Y-axis
          formatter: (value) => (value === 0 ? value : `${value}k`),
        },
        splitLine: {
          lineStyle: {
            type: "dashed",
            color: "#EFEFEF",
          },
        },
      },
      {
        type: "value",
        axisLine: {
          show: true,
          lineStyle: {
            color: "#DADADA", // Right Y-axis color
          },
        },
        axisLabel: {
          color: "#FFA500", // Match label color with Y-axis
          formatter: (value) => (value === 0 ? value : `${value}k`),
        },
        splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#EFEFEF",
            },
          },
      },
    ],
    series: [
      {
        name: "Dataset 1",
        type: "line",
        data: [100, 200, 300, 700, 400, 500, 450, 400, 480, 500, 700, 800,],
        itemStyle: {
          color: "#F95C39",
        },
        lineStyle: {
          width: 3,
          color: "#F95C39",
        },
        smooth: false,
        symbol: "none",
      },
      {
        name: "Dataset 2",
        type: "line",
        // yAxisIndex: 1,
        data: [150, 180, 240, 600, 350, 500, 30, 40, 50, 55, 60, 80],
        itemStyle: {
          color: "#FFA500",
        },
        lineStyle: {
          width: 3,
          color: "#FFA500",
        },
        smooth: false,
                symbol: "none",

      },
    ],
  };

  return <ReactECharts option={options} style={{ height: "400px", width: "100%", background: "#FBFBFD", paddingTop: "20px", paddingLeft: "10px"  }} />;
};

export default DualAxisChart;
